import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from './SectionHeader';
import { SummaryRow } from './SummaryRow';

interface PickupSectionProps {
  address: string;
}

export function PickupSection({ address }: PickupSectionProps) {
  const { t } = useTranslation();

  return (
    <div className='rounded-2xl border border-sd-border bg-sd-card p-5'>
      <SectionHeader icon={MapPin} title={String(t('pickup_location'))} />

      <div className='divide-y divide-sd-border'>
        <SummaryRow label={String(t('warehouse'))} value={address} />
      </div>
    </div>
  );
}
